import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#515669',
        color: '#f5f5f5',
        p: { xs: 1, sm: 2 }, // Adjust padding for mobile
        textAlign: 'center',
        boxShadow: '0 -4px 6px rgba(0, 0, 0, 0.1)', // Top shadow
      }}
    >
      <Typography variant="body2" sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>
        &copy; {new Date().getFullYear()} My Portfolio. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
